// src/Maintenance.js
import React, { useState, useEffect } from 'react';
import logo from './imagesHome/logoconta.png';
import './Maintenance.css';

const Maintenance = () => {
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [progress, setProgress] = useState(0);
  const [submitError, setSubmitError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  // 🔗 API URL din .env
  const apiUrl = process.env.REACT_APP_API_URL;

  // Progress bar animation
  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prev) => (prev >= 88 ? 88 : prev + 1));
    }, 50);

    return () => clearInterval(interval);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitError('');

    if (!email) return;

    setIsLoading(true);

    try {
      const response = await fetch(`${apiUrl}/notify-maintenance`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'A apărut o eroare. Încearcă din nou.');
      }

      setIsSubmitted(true);
      setEmail('');
    } catch (err) {
      setSubmitError(err.message || 'Eroare de rețea. Încearcă din nou.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="maintenance-container">
      {/* Background animat */}
      <div className="maintenance-bg-animation">
        <div className="circle circle-1"></div>
        <div className="circle circle-2"></div>
        <div className="circle circle-3"></div>
      </div>

      <div className="maintenance-content">
        {/* Logo */}
        <div className="maintenance-logo-wrapper">
          <img src={logo} alt="Logo ContaLearn" className="maintenance-logo" />
          <div className="logo-pulse"></div>
        </div>

        {/* Badge */}
		<div className="maintenance-badge">
		  <span className="badge-icon">🚀</span>
		  <span>Ceva extraordinar se pregateste</span>
		</div>

        {/* Titlu */}
        <h1 className="maintenance-title">ContaLearn vine in curand</h1>

        {/* Descriere */}
        <p className="maintenance-description">
          Construim cea mai moderna platforma de invatare a contabilitatii din
          Romania. Lucram din greu pentru a-ti oferi o experienta interactiva,
          eficienta si accesibila!
        </p>

        {/* Progress */}
        <div className="maintenance-progress-section">
          <div className="progress-info">
            <span>Progres dezvoltare</span>
            <span className="progress-percentage">{progress}%</span>
          </div>
          <div className="progress-bar">
            <div
              className="progress-fill"
              style={{ width: `${progress}%` }}
            />
          </div>
        </div>

        {/* Features */}
        <div className="maintenance-features">
          <div className="maintenance-feature">
            <div className="feature-icon">📚</div>
            <h3>Cursuri complete</h3>
            <p>De la bazele contabilitatii la contabilitate financiara</p>
          </div>
          <div className="maintenance-feature">
            <div className="feature-icon">🎮</div>
            <h3>Jocuri interactive</h3>
            <p>Invatare prin practica</p>
          </div>
          <div className="maintenance-feature">
            <div className="feature-icon">🎓</div>
            <h3>Certificare</h3>
            <p>Iti atesta efortul depus pentru invatare</p>
          </div>
          <div className="maintenance-feature">
            <div className="feature-icon">📱</div>
            <h3>Acces oriunde</h3>
            <p>Desktop & Mobile</p>
          </div>
        </div>

        {/* Newsletter */}
        <div className="maintenance-notify">
          <h3>Fii primul care afla cand lansam!</h3>
          <p>Lasa-ne email-ul si te anuntam cand platforma este gata</p>

          {!isSubmitted ? (
            <form onSubmit={handleSubmit} className="notify-form">
              <input
                type="email"
                placeholder="adresa@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="notify-input"
                disabled={isLoading}
              />
              <button
                type="submit"
                className="notify-button"
                disabled={isLoading}
              >
                {isLoading ? 'Se trimite...' : 'Anunta-ma'}
              </button>

              {submitError && (
                <div style={{ color: 'red', marginTop: 8 }}>
                  {submitError}
                </div>
              )}
            </form>
          ) : (
            <div className="notify-success">
              <span className="success-icon">✓</span>
              <p>Multumim! Te vom anunta cand lansam.</p>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="maintenance-footer">
          <p>📧 Contact: contact@contalearn.ro</p>
          <p className="maintenance-thanks">
            Multumim pentru rabdare si intelegere 💙
          </p>
        </div>
      </div>
    </div>
  );
};

export default Maintenance;
